import * as types from "./businessTrustpassActionTypes";
import * as apiUrls from "./businessTrustpassApiUrls";
import Cookies from "universal-cookie";
import { startLoading, stopLoading } from "../shared/actions";

const cookies = new Cookies();

export function createBusinessTrustpass(userId, callbackFunction) {
  return (dispatch) => {
    return fetch(apiUrls.apiV2CreateUserBusinessTrustpassUrl(userId), {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
      body: JSON.stringify({}),
    })
    .then(response => response.json())
    .then(json => {
      callbackFunction();
      dispatch({
        type: types.RECEIVE_BUSINESS_TRUSTPASS,
        payload: json,
      });
    });
  };
}

export function updateBusinessTrustpass(urlProps, body, onSuccess, onError) {
  return (dispatch) => {
    const { userId, businessTrustpassId } = urlProps;
    const apiUrl = apiUrls.apiV2UpdateUserBusinessTrustpassUrl;

    return fetch(apiUrl(userId, businessTrustpassId), {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
      body: JSON.stringify({ business_trustpass: body }),
    })
    .then(response => {
      response.json().then(json => {
        if (response.ok) {
          dispatch({
            type: types.RECEIVE_BUSINESS_TRUSTPASS,
            payload: json,
          });

          dispatch({
            type: types.UPDATE_BUSINESS_TRUSTPASS_INFO,
            payload: json,
          });

          onSuccess();
        } else {
          onError(json.errors);
        }
      })
    })
  };
}

export function fetchBusinessTrustpasses(userId) {
  return (dispatch) => {
    dispatch(startLoading());
    return fetch(apiUrls.apiV2FetchUserBusinessTrustpassesUrl(userId), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: types.RECEIVE_BUSINESS_TRUSTPASS,
        payload: json[0],
      })
      dispatch(stopLoading());
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch(stopLoading());
    });
  };
}

export function fetchBusinessTrustpass(userId, businessTrustpassId) {
  return (dispatch) => {
    const apiUrl = apiUrls.apiV2FetchUserBusinessTrustpassUrl;
    return fetch(apiUrl(userId, businessTrustpassId), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
    })
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: types.RECEIVE_BUSINESS_TRUSTPASS,
        payload: json,
      })
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

export function submitBusinessTrustpass(userId, businessTrustpassId) {
  return (dispatch) => {
    const apiUrl = apiUrls.apiV2SubmitUserBusinessTrustpassUrl;

    return fetch(apiUrl(userId, businessTrustpassId), {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
    })
    .then(response => {
      response.json().then(json => {
        dispatch({
          type: types.RECEIVE_BUSINESS_TRUSTPASS,
          payload: json,
        });
        dispatch({
          type: 'BUSINESS_TRUSTPASS_STATUS_UPDATE',
          payload: 'under verification',
        });
      })
    })
  };
}



// WEBPACK FOOTER //
// ./src/features/trustpass/businessTrustpassActions.js